import * as CL from '@design-system/component-library';
import classNames from 'classnames';
import { useLocation } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses';
import { paths } from '../../common/constants/pathVariables';
import { additionalServicesMsg, noAdditionalServicesMsg, t } from '../../common/i18n';
import { CATEGORY_URL } from '../../common/utils/categoryUtils';
import { getRecurringPriceAsText } from '../../common/utils/priceUtils';
import { getSubscriptionUrlId } from '../../common/utils/subscriptionUtils';
import { DetailsWithInfoColumn } from '../DetailsWithInfoColumn/DetailsWithInfoColumn';
import { Loading } from '../Loading';
import { SubscriptionAdditionalService } from '../SubscriptionAdditionalService/SubscriptionAdditionalService';
import { CardContent } from './Components/CardContent';
import { DeviceChangeRequestDisclaimer } from './Components/DeviceChangeRequestDisclaimer';
import { getAddOnStatus } from './addOnDependencyUtils';
import type { Subscription } from '../../generated/api/subscription';
import type { SubscriptionDetails as SubscriptionDetailsModel } from '../../generated/api/subscriptionDetails';

interface DeviceAddOnsProps {
  subscription: Subscription;
  details?: SubscriptionDetailsModel;
  hasPendingActions: boolean;
}

interface InfoColumnProps {
  subscription: Subscription;
}

const InfoColumn = ({ subscription }: InfoColumnProps) => (
  <CL.Card
    content={<CardContent subscription={subscription} />}
    type="dark"
    analytics-parent-element="OmaElisa instruction card"
  />
);

export const DeviceSubscriptionAddons = ({ details, subscription, hasPendingActions }: DeviceAddOnsProps) => {
  const { search } = useLocation();
  if (!details) {
    return <Loading />;
  }

  const addons = (details.selectedAddOns ?? []).filter(addon => addon.display === true);
  const category = 'device';
  const changeRequestDisclaimer = hasPendingActions ? <DeviceChangeRequestDisclaimer /> : null;
  return (
    <DetailsWithInfoColumn
      infoColumnContent={<InfoColumn subscription={subscription} />}
      disclaimerContent={changeRequestDisclaimer}
    >
      <h3 className={classNames(dsClass.H3_BOOK)}>{t.LXSR(additionalServicesMsg)}</h3>
      {addons.length === 0 && <span>{t.EIYK(noAdditionalServicesMsg)}</span>}
      {addons.map((e, i) => (
        <SubscriptionAdditionalService
          key={e.addOnCode + i}
          title={e.addOnProductName}
          addOnStatusInfo={getAddOnStatus(true)}
          isEmployee={false}
          additionalServicePath={
            category && subscription && search
              ? `${paths.PS_HOME}/${CATEGORY_URL[category]}/${getSubscriptionUrlId(subscription)}/${e.addOnCode + search}`
              : undefined
          }
          priceInfo={{ value: getRecurringPriceAsText(e.addOnMonthlyRecurringCharge) }}
        />
      ))}
    </DetailsWithInfoColumn>
  );
};
